import React from 'react';
import { useFlag } from '../../redux/flags/hooks/useFlag';
import ErrorBoundary from '../../ErrorBoundary';
import BasicUserLink from '../_partials/BasicUserLink/BasicUserLink';
import BasicUserName from '../_partials/BasicUserName';
export var UserLink = function (_a) {
    var user = _a.user, showSymbol = _a.showSymbol, symbolClassName = _a.symbolClassName, usernameClassName = _a.usernameClassName, linkTo = _a.linkTo, className = _a.className, biData = _a.biData, children = _a.children;
    var enableUserSymbolsPopup = useFlag('user_symbols_modal');
    return (React.createElement(ErrorBoundary, null,
        React.createElement(BasicUserLink, { user: user, linkTo: linkTo, className: className, biData: biData }, children ? (children) : (React.createElement(BasicUserName, { user: user, showSymbol: showSymbol, symbolOpensPopup: enableUserSymbolsPopup, symbolClassName: symbolClassName, usernameClassName: usernameClassName })))));
};
UserLink.displayName = 'UserLink';
export default UserLink;
//# sourceMappingURL=UserLink.js.map